/**
 * Константы и утилиты для работы с юрлицами
 */

export type LegalEntity = 'DOKTOR_SERVER' | 'DOKTOR_TRADE' | 'IP_ZALESSKY';

// Короткие названия юрлиц
export const LEGAL_ENTITY_LABELS: Record<LegalEntity, string> = {
  DOKTOR_SERVER: 'Доктор Сервер',
  DOKTOR_TRADE: 'Доктор Трейд',
  IP_ZALESSKY: 'ИП Залесский',
};

// Официальные названия юрлиц (для документов)
export const LEGAL_ENTITY_OFFICIAL_NAMES: Record<LegalEntity, string> = {
  DOKTOR_SERVER: 'ООО «Доктор Сервер»',
  DOKTOR_TRADE: 'ООО «Доктор Трейд»',
  IP_ZALESSKY: 'ИП Залесский Е.Б.',
};

// Краткие названия (для таблиц)
export const LEGAL_ENTITY_SHORT_LABELS: Record<LegalEntity, string> = {
  DOKTOR_SERVER: 'ДС',
  DOKTOR_TRADE: 'ДТ',
  IP_ZALESSKY: 'ИП',
};

// Получить название юрлица
export function getLegalEntityLabel(
  key: string,
  format: 'short' | 'full' | 'official' = 'full'
): string {
  const maps = {
    short: LEGAL_ENTITY_SHORT_LABELS,
    full: LEGAL_ENTITY_LABELS,
    official: LEGAL_ENTITY_OFFICIAL_NAMES,
  };
  return maps[format][key as LegalEntity] || key;
}
